// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__elKDH","logo":"style__logo__IB2hY"};